// extracted by mini-css-extract-plugin
module.exports = {"ColorPicker":"ColorPicker_ColorPicker__1cKVB"};